import { WALLET_PROVIDER_ICONS } from 'features/auth/constants'
import type { SolanaConnectorProvider } from 'features/auth/utils/get-solana-connector-providers'

interface Props {
  provider: SolanaConnectorProvider
  /** The icon the installed wallet announces (Wallet Standard data URI). */
  adapterIcon?: string
  /** Shown when neither logo exists (an app that is not installed). */
  fallback?: React.ReactElement | null
}

/** Our own logo when we have one, otherwise the icon the wallet itself announces. */
export const ProviderIcon: React.FC<Props> = ({
  provider,
  adapterIcon,
  fallback = null
}) => {
  const ownIcon =
    WALLET_PROVIDER_ICONS[provider.id as keyof typeof WALLET_PROVIDER_ICONS]
  if (ownIcon) return ownIcon
  if (!adapterIcon) return fallback

  return (
    <img
      src={adapterIcon}
      alt=''
      width={24}
      height={24}
    />
  )
}
